import { PartImage } from '../types/part/partTypes'

type ObjectToCompare = PartImage[] | string[]
export const isDeepEqualSimple = (obj1: ObjectToCompare, obj2: ObjectToCompare): boolean =>
    JSON.stringify(obj1) === JSON.stringify(obj2)
